<div class="flex flex-col font-serif text-gray-900">

  <!-- ── 1. HERO BANNER (full-width image only) ──────────────────────────── -->
  <section class="relative w-full overflow-hidden">
    <!-- min-h-[150px] on mobile; desktop uses spacer natural height; bg matches image cream -->
    <div class="relative min-h-[150px] md:min-h-0 bg-[#f2ece5]">
      <!-- Skeleton loader -->
      <div *ngIf="slides.length === 0"
        class="w-full aspect-[21/9] skeleton"></div>
      <!-- Invisible spacer (layout only): sizes container to natural image height on all screens -->
      <img *ngIf="slides.length > 0"
        [src]="slides[0].mobile_image || slides[0].image || slides[0].img || slides[0].banner_image"
        alt="" aria-hidden="true"
        class="block w-full h-auto invisible pointer-events-none select-none md:hidden" />
      <img *ngIf="slides.length > 0"
        [src]="slides[0].image || slides[0].img || slides[0].banner_image"
        alt="" aria-hidden="true"
        class="hidden md:block w-full h-auto invisible pointer-events-none select-none" />
      <ng-container *ngIf="slides.length > 0">
        <div *ngFor="let slide of slides; let i = index"
          class="absolute inset-0 transition-opacity duration-1000 flex items-center"
          [class.opacity-100]="i === currentSlide" [class.opacity-0]="i !== currentSlide"
          [class.cursor-pointer]="slide.button_link"
          [class.pointer-events-none]="i !== currentSlide"
          (click)="slide.button_link && router.navigate([slide.button_link])">
          <!-- Mobile image -->
          <img *ngIf="slide.mobile_image" [src]="slide.mobile_image" [alt]="slide.title || 'Wall Art'"
            class="w-full h-auto block md:hidden" />
          <!-- Desktop image -->
          <img [src]="slide.image || slide.img || slide.banner_image" [alt]="slide.title || 'Wall Art'"
            [ngClass]="slide.mobile_image ? 'hidden md:block' : 'block'"
            class="w-full h-auto" />
        </div>
      </ng-container>
      <!-- Slide dots -->
      <div *ngIf="slides.length > 1" class="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-2 z-10">
        <button *ngFor="let s of slides; let i = index" (click)="currentSlide = i"
          [ngClass]="i === currentSlide ? 'w-2.5 h-2.5 bg-[#600b0b]' : 'w-2 h-2 bg-gray-400/60'"
          class="rounded-full transition-all duration-300"></button>
      </div>
    </div>
  </section>

  <!-- ── 2. WIDGET 0 — CTA BANNER ──────────────────────────────────────────── -->
  <ng-container *ngIf="widgets.length > 0 && widgets[0]?.published == 1">
    <!-- Text type widget -->
    <section *ngIf="widgets[0]?.text_type == 0" class="bg-[#600b0b] py-8 px-6 md:px-12">
      <div class="max-w-[1440px] mx-auto flex flex-col md:flex-row items-center justify-between gap-6">
        <div class="flex-1 text-white">
          <div class="text-xl md:text-2xl font-serif font-medium leading-snug" [innerHTML]="widgets[0]?.title">
          </div>
          <div class="text-sm text-white/80 mt-2 font-light leading-relaxed" [innerHTML]="widgets[0]?.subtitle">
          </div>
        </div>
        <a *ngIf="widgets[0]?.button_link" [href]="widgets[0]?.button_link"
          class="shrink-0 border-2 border-white text-white px-7 py-3 rounded-xl font-bold uppercase tracking-[0.15em] text-[10px] hover:bg-white hover:text-[#600b0b] transition-all">
          {{ widgets[0]?.button_title || 'Explore' }}
        </a>
      </div>
    </section>
    <!-- Image type widget -->
    <section *ngIf="widgets[0]?.text_type == 1" class="py-4 px-6 md:px-12 bg-white">
      <div class="max-w-[1440px] mx-auto">
        <a [href]="widgets[0]?.button_link || '#'">
          <img [src]="widgets[0]?.image" [alt]="widgets[0]?.alt_text || 'Widget'"
            class="w-full rounded-2xl object-cover" />
        </a>
      </div>
    </section>
  </ng-container>
  <div *ngIf="widgets.length === 0 || widgets[0]?.published != 1" class="h-3 bg-white"></div>

  <!-- ── 3. TOP CATEGORIES (Trending Themes Carousel) ───────────────────────── -->
  <section *ngIf="topCategories.length > 0" class="py-12 px-6 md:px-12 bg-white">
    <div class="max-w-[1440px] mx-auto">
      <!-- Heading with diamond ornament -->
      <div class="text-center mb-10">
        <h2 class="text-2xl md:text-3xl lg:text-4xl font-serif font-normal text-gray-900 tracking-wide">
          <!-- {{ getHeading(0, 'Trending Themes') }} -->
          Trending Themes
        </h2>
        <div class="flex items-center justify-center gap-3 mt-3">
          <div class="w-12 h-[2px] bg-[#c49a6c]"></div>
          <svg class="w-5 h-5 text-[#c49a6c]" viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 2l3 7h-2v4h2l-3 7-3-7h2v-4h-2l3-7z" transform="rotate(45 12 12)" />
          </svg>
          <div class="w-12 h-[2px] bg-[#c49a6c]"></div>
        </div>
      </div>

      <!-- Carousel wrapper -->
      <div class="relative">
        <!-- Left arrow -->
        <button (click)="scrollCategories('left')"
          class="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 z-10 w-11 h-11 bg-white rounded-full shadow-lg border border-gray-200 flex items-center justify-center text-gray-600 hover:text-[#600b0b] hover:shadow-xl transition-all">
          <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor"
            stroke-width="2">
            <polyline points="15 18 9 12 15 6" />
          </svg>
        </button>

        <!-- Scrollable track -->
        <div #categoryCarousel class="flex gap-5 overflow-x-auto scroll-smooth scrollbar-hide px-2 py-2"
          style="scrollbar-width: none; -ms-overflow-style: none;">
          <div *ngFor="let cat of topCategories" (click)="navigateToCategory(cat)"
            class="group cursor-pointer flex flex-col items-center gap-3 shrink-0"
            style="width: calc(25% - 15px); min-width: 200px;">
            <div
              class="w-full aspect-[3/4] rounded-lg overflow-hidden shadow-sm group-hover:shadow-xl transition-all duration-500 relative">
              <img [src]="getImageUrl(cat.image)" [alt]="cat.title"
                class="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
            </div>
            <span
              class="font-serif text-gray-800 text-sm md:text-base tracking-wide font-normal group-hover:text-[#600b0b] transition-colors text-center leading-tight">
              {{ cat.title }}
            </span>
          </div>
        </div>

        <!-- Right arrow -->
        <button (click)="scrollCategories('right')"
          class="absolute right-0 top-1/2 -translate-y-1/2 translate-x-4 z-10 w-11 h-11 bg-white rounded-full shadow-lg border border-gray-200 flex items-center justify-center text-gray-600 hover:text-[#600b0b] hover:shadow-xl transition-all">
          <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor"
            stroke-width="2">
            <polyline points="9 18 15 12 9 6" />
          </svg>
        </button>
      </div>
    </div>
  </section>

  <!-- ── 4. WALL ART PRODUCT TYPES (2x2 Grid) ──────────────────────────────── -->
  <section class="bg-white">
    <div class="grid grid-cols-1 sm:grid-cols-2 gap-[2px]">
      <div *ngFor="let pt of productTypes" (click)="navigateToArtReady(pt.art_type_id)"
        class="group cursor-pointer relative aspect-[4/3] overflow-hidden">
        <img [src]="pt.image" [alt]="pt.label || pt.title || pt.name"
          class="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
        <div class="absolute inset-0 bg-black/30 group-hover:bg-black/40 transition-colors duration-500"></div>
        <div class="absolute bottom-0 left-0 right-0 p-6 md:p-8 text-center">
          <h3 class="text-xl md:text-2xl font-serif font-medium text-white leading-tight">
            {{ pt.label }}
          </h3>
          <p class="text-xs md:text-sm text-white/80 font-serif mt-1">
            {{ pt.subtitle || pt.desc || 'Elevate Your Space With Our Art Collection' }}
          </p>
        </div>
      </div>
    </div>
  </section>

  <!-- ── 5. DISCOVER MORE (Carousel) ───────────────────────────────────────── -->
  <section *ngIf="artSearchCategories.length > 0" class="py-12 px-6 md:px-12 bg-white">
    <div class="max-w-[1440px] mx-auto">
      <!-- Heading with diamond ornament -->
      <div class="text-center mb-10">
        <h2 class="text-2xl md:text-3xl lg:text-4xl font-serif font-normal text-gray-900 tracking-wide">
          {{ 'Discover More' }}
        </h2>
        <div class="flex items-center justify-center gap-3 mt-3">
          <div class="w-12 h-[2px] bg-[#c49a6c]"></div>
          <svg class="w-5 h-5 text-[#c49a6c]" viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 2l3 7h-2v4h2l-3 7-3-7h2v-4h-2l3-7z" transform="rotate(45 12 12)" />
          </svg>
          <div class="w-12 h-[2px] bg-[#c49a6c]"></div>
        </div>
      </div>

      <!-- Carousel wrapper -->
      <div class="relative">
        <!-- Left arrow -->
        <button (click)="scrollDiscover('left')"
          class="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 z-10 w-11 h-11 bg-white rounded-full shadow-lg border border-gray-200 flex items-center justify-center text-gray-600 hover:text-[#600b0b] hover:shadow-xl transition-all">
          <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor"
            stroke-width="2">
            <polyline points="15 18 9 12 15 6" />
          </svg>
        </button>

        <!-- Scrollable track -->
        <div #discoverCarousel class="flex gap-5 overflow-x-auto scroll-smooth px-2 py-2"
          style="scrollbar-width: none; -ms-overflow-style: none;">
          <div *ngFor="let cat of featuredProducts" (click)="navigateToProduct(cat)"
            class="group cursor-pointer shrink-0" style="width: calc(25% - 15px); min-width: 240px;">
            <div
              class="w-full aspect-[4/3] rounded-lg overflow-hidden shadow-sm group-hover:shadow-xl transition-all duration-500">
              <img [src]="cat.image_1" [alt]="cat.label || cat.title || cat.name"
                class="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
            </div>
          </div>
        </div>

        <!-- Right arrow -->
        <button (click)="scrollDiscover('right')"
          class="absolute right-0 top-1/2 -translate-y-1/2 translate-x-4 z-10 w-11 h-11 bg-white rounded-full shadow-lg border border-gray-200 flex items-center justify-center text-gray-600 hover:text-[#600b0b] hover:shadow-xl transition-all">
          <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor"
            stroke-width="2">
            <polyline points="9 18 15 12 9 6" />
          </svg>
        </button>
      </div>
    </div>
  </section>

  <!-- ── WHY MAHATTAART? ────────────────────────────────────────────────────── -->
  <section *ngIf="requirements.length > 0" class="py-16 px-6 md:px-12 bg-[#fafafa]">
    <div class="max-w-[1320px] mx-auto">

      <!-- Heading -->
      <div class="text-center mb-14">
        <h2 class="text-[28px] md:text-[34px] font-serif text-[#2c2c2c] tracking-[1px]">
          {{ getHeading(8, 'Why MahattaArt?') }}
        </h2>

        <!-- Divider -->
        <div class="flex items-center justify-center gap-4 mt-4">
          <div class="w-12 h-[1.5px] bg-[#c49a6c]"></div>

          <div class="w-4 h-4 border border-[#c49a6c] rotate-45"></div>

          <div class="w-12 h-[1.5px] bg-[#c49a6c]"></div>
        </div>
      </div>

      <!-- Grid -->
      <div class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-y-12">

        <div *ngFor="let req of requirements" class="flex flex-col items-center text-center">

          <!-- Icon -->
          <div class="w-16 h-16 flex items-center justify-center mb-3">
            <img *ngIf="req.icon || req.image" [src]="'https://content.mahattaart.com/' + (req.icon || req.image)"
              [alt]="req.title || req.name" class="w-12 h-12 object-contain opacity-90" />

            <!-- fallback -->
            <svg *ngIf="!req.icon && !req.image" xmlns="http://www.w3.org/2000/svg" class="w-10 h-10 text-[#8b1216]"
              viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
              <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
            </svg>
          </div>

          <!-- Text -->
          <p class="text-[14px] font-serif text-[#4a4a4a] leading-snug max-w-[140px]">
            {{ req.title || req.name }}
          </p>

        </div>

      </div>
    </div>
  </section>

</div>